export default __webpack_public_path__ + "static/media/warning.38888051.png";